export default "__VITE_ASSET__CSKKZLTS__"